// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sso {
  background-color: var(--color-bg-login);
  width: 100vw;
  height: 100vh;
}

.sso h1 {
  text-align: center;
  margin: auto auto;
}

.ssoFormContainer {
  width: 448px;
  min-height: 455px;
  background-color: var(--color-bg-login-box);
  margin-left: auto;
  margin-right: auto;
  margin-top: 200px;
  box-shadow: 0px 3px 6px var(--color-theme-cloud);
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 25vh; 
  left: 50vw; 
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/@_pages/SingleSignOn/SingleSignOn.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC","sourcesContent":[".sso {\n  background-color: var(--color-bg-login);\n  width: 100vw;\n  height: 100vh;\n}\n\n.sso h1 {\n  text-align: center;\n  margin: auto auto;\n}\n\n.ssoFormContainer {\n  width: 448px;\n  min-height: 455px;\n  background-color: var(--color-bg-login-box);\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 200px;\n  box-shadow: 0px 3px 6px var(--color-theme-cloud);\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 25vh; \n  left: 50vw; \n  transform: translate(-50%, -50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
